import React, { useState } from "react"
import {
    FormControl,
    FormErrorMessage,
    Button,
    CircularProgress,
    Box,
    Divider, Image,
    Card,
    CardBody,
    Heading,
    Grid
} from '@chakra-ui/react'
import InputFile from "./InputFile"
import { Formik } from 'formik'
import { FormValidator } from '../utils/validationForms'
import { APIpath } from '../actions'
import placeholder from '../multimedia/placeholder.jpg'

const replaceImage = (error) => {
    error.target.src = placeholder;
}

export const CarImageForm = (props) => {

    const { car, carImage } = props

    const [imageVersion, setImageVersion] = useState(Date.now());

    return (
        <Box w={"full"}>

            <Heading size={"lg"}> Imágenes subidas </Heading>

            <br />
            <Grid templateColumns='repeat(5, 1fr)' gap={6}>
                <Card maxW='sm'>
                    <CardBody>
                        <Image src={`${APIpath}/carro/image/${car.id}/1?v=${imageVersion}`} alt={"preview" + car.id}  key={`1-${car.id}-${imageVersion}`} h={"200px"} w={"300px"} m={"auto"} onError={replaceImage} objectFit={"cover"} />
                        <Heading size={"md"} textAlign={"center"}>Foto delantera</Heading>
                    </CardBody>
                </Card>

                <Card maxW='sm'>
                    <CardBody>
                        <Image src={`${APIpath}/carro/image/${car.id}/2?v=${imageVersion}`} alt={"preview" + car.id}  key={`2-${car.id}-${imageVersion}`} h={"200px"} w={"300px"} m={"auto"} onError={replaceImage} objectFit={"cover"} />
                        <Heading size={"md"} textAlign={"center"}>Foto lateral</Heading>
                    </CardBody>
                </Card>

                <Card maxW='sm'>
                    <CardBody>
                        <Image src={`${APIpath}/carro/image/${car.id}/3?v=${imageVersion}`} alt={"preview" + car.id}  key={`3-${car.id}-${imageVersion}`} h={"200px"} w={"300px"} m={"auto"} onError={replaceImage} objectFit={"cover"} />
                        <Heading size={"md"} textAlign={"center"}>Foto trasera</Heading>
                    </CardBody>
                </Card>

                <Card maxW='sm'>
                    <CardBody>
                        <Image src={`${APIpath}/carro/image/${car.id}/4?v=${imageVersion}`} alt={"preview" + car.id}  key={`4-${car.id}-${imageVersion}`} h={"200px"} w={"300px"} m={"auto"} onError={replaceImage} objectFit={"cover"} />
                        <Heading size={"md"} textAlign={"center"}>Foto motor</Heading>
                    </CardBody>
                </Card>

                <Card maxW='sm'>
                    <CardBody>
                        <Image src={`${APIpath}/carro/image/${car.id}/5?v=${imageVersion}`} alt={"preview" + car.id}  key={`5-${car.id}-${imageVersion}`} h={"200px"} w={"300px"} m={"auto"} onError={replaceImage} objectFit={"cover"} />
                        <Heading size={"md"} textAlign={"center"}>Foto Kilometraje</Heading>
                    </CardBody>
                </Card>
            </Grid>

            <Divider />

            <br />

            <Heading size={"md"} > Subida de Imágenes </Heading>

            <Formik
                initialValues={{
                    image1: null,
                    image2: null,
                    image3: null,
                    image4: null,
                    image5: null
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    setSubmitting(true)
                    const formData = new FormData()
                    for (let value in values) {
                        formData.append(value, values[value])
                    }
                    formData.append('id', car.id)

                    Promise.resolve(carImage(formData))
                        .then(() => {
                            setSubmitting(false)
                            setImageVersion(Date.now())
                            resetForm()
                        })
                }}
            >
                {({ values, errors, touched, handleSubmit, isSubmitting, setFieldValue }) =>
                    <form onSubmit={handleSubmit} encType="multipart/form-data">

                        <FormControl isInvalid={errors.image1 && touched.image1}>
                            <InputFile name={"image1"} label={"Foto delantera"} setFieldValue={setFieldValue} value={values.image1} />
                            <FormErrorMessage>{errors.image1}</FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={errors.image2 && touched.image2}>
                            <InputFile name={"image2"} label={"Foto lateral"} setFieldValue={setFieldValue} value={values.image2} />
                            <FormErrorMessage>{errors.image2}</FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={errors.image3 && touched.image3}>
                            <InputFile name={"image3"} label={"Foto trasera"} setFieldValue={setFieldValue} value={values.image3} />
                            <FormErrorMessage>{errors.image3}</FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={errors.image4 && touched.image4}>
                            <InputFile name={"image4"} label={"Foto motor"} setFieldValue={setFieldValue} value={values.image4} />
                            <FormErrorMessage>{errors.image4}</FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={errors.image5 && touched.image5}>
                            <InputFile name={"image5"} label={"Foto kilometraje"} setFieldValue={setFieldValue} value={values.image5} />
                            <FormErrorMessage>{errors.image5}</FormErrorMessage>
                        </FormControl>

                        <Button colorScheme={"easycar2"} variant="outline" type="submit" mt={4} disabled={isSubmitting}>
                            {isSubmitting ? <CircularProgress /> : 'Guardar'}
                        </Button>
                    </form>
                }
            </Formik>
        </Box>
    )
}